import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function DashboardSkeleton() {
  return (
    <div className="min-h-screen bg-background pb-24 p-4">
      <div className="max-w-md mx-auto space-y-6">
        {/* Daily Goal Ring Skeleton */}
        <div className="pt-8 pb-4">
          <div className="flex flex-col items-center space-y-4">
            <Skeleton className="h-48 w-48 rounded-full" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-24" />
            </div>
          </div>
        </div>

        {/* Prestige Progress Bar Skeleton */}
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-5 rounded" />
            <Skeleton className="h-5 w-32" />
          </div>
          <Card className="p-4">
            <Skeleton className="h-3 w-full" />
          </Card>
        </div>

        {/* Stats Grid - 2x2 (4 cards) */}
        <div className="grid grid-cols-2 gap-3">
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} className="p-4">
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-8 w-8 rounded-lg" />
                  <Skeleton className="h-3 w-16" />
                </div>
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-3 w-24" />
              </div>
            </Card>
          ))}
        </div>

        {/* Weekly Progress Chart */}
        <Card className="p-4">
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-40" />
              <Skeleton className="h-5 w-16" />
            </div>
            <Skeleton className="h-40 w-full rounded-lg" />
          </div>
        </Card>

        {/* Streak Strip */}
        <Card className="p-4">
          <div className="space-y-3">
            <Skeleton className="h-5 w-32" />
            <div className="flex gap-2 overflow-hidden">
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <Skeleton key={i} className="h-12 flex-1 rounded" />
              ))}
            </div>
          </div>
        </Card>

        {/* Lifetime Graph */}
        <Card className="p-4">
          <div className="space-y-3">
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-48 w-full rounded-lg" />
          </div>
        </Card>

        {/* Study Session History */}
        <Card className="relative overflow-hidden p-5 shadow-card bg-gradient-to-br from-card/90 to-card/70 backdrop-blur-sm">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Skeleton className="h-12 w-12 rounded-xl" />
                <div className="space-y-2">
                  <Skeleton className="h-5 w-32" />
                  <Skeleton className="h-3 w-24" />
                </div>
              </div>
              <Skeleton className="h-8 w-20 rounded-full" />
            </div>
            <div className="space-y-3">
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} className="h-20 w-full rounded-xl" />
              ))}
            </div>
          </div>
        </Card>

        {/* Premium Analytics Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[1, 2].map((i) => (
            <Card key={i} className="p-4">
              <div className="space-y-3">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-8 w-20" />
                <Skeleton className="h-3 w-full" />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
